(() => {
  const INITIAL_REVIEW_COUNT = 6;
  const REVIEW_BATCH_SIZE = 6;
  const MOBILE_MEDIA_QUERY = '(max-width: 749px)';

  /**
   * Activate the optimizations only on product templates
   * containing the data-priority-pdp-ux marker.
   */
  const activatePage = () => {
    const prioritySection = document.querySelector(
      '[data-priority-pdp-ux]'
    );

    if (!prioritySection) {
      document.documentElement.classList.remove(
        'schwer-priority-pdp-ux'
      );

      return false;
    }

    document.documentElement.classList.add(
      'schwer-priority-pdp-ux'
    );

    return true;
  };

  /**
   * Return all direct review cards inside a Trustoo list.
   */
  const reviewCards = (list) => {
    return [
      ...list.querySelectorAll(':scope > .grid-review'),
    ];
  };

  /**
   * Calculate how many reviews should currently be visible.
   */
  const visibleReviewCount = (list, total) => {
    const savedCount = Number(
      list.dataset.schwerVisibleReviews ||
        INITIAL_REVIEW_COUNT
    );

    return Math.min(savedCount, total);
  };

  /**
   * Remove the mobile review modifications when switching
   * back to desktop.
   */
  const resetReviewList = (list) => {
    reviewCards(list).forEach((card) => {
      card.hidden = false;
    });

    delete list.dataset.schwerVisibleReviews;

    const loadMoreButton =
      list.parentElement?.querySelector(
        ':scope > .schwer-reviews-load-more'
      );

    loadMoreButton?.remove();
  };

  /**
   * Reveal the next group of reviews.
   */
  const revealNextReviewBatch = (list) => {
    const currentCount = Number(
      list.dataset.schwerVisibleReviews ||
        INITIAL_REVIEW_COUNT
    );

    list.dataset.schwerVisibleReviews = String(
      currentCount + REVIEW_BATCH_SIZE
    );

    enhanceReviews();
  };

  /**
   * Create the mobile Load more reviews button.
   */
  const createLoadMoreButton = (list) => {
    const existingButton =
      list.parentElement?.querySelector(
        ':scope > .schwer-reviews-load-more'
      );

    if (existingButton) {
      return existingButton;
    }

    const button = document.createElement('button');

    button.type = 'button';
    button.className = 'schwer-reviews-load-more';
    button.textContent = 'Load more reviews';

    button.addEventListener('click', () => {
      revealNextReviewBatch(list);
    });

    list.insertAdjacentElement('afterend', button);

    return button;
  };

  /**
   * Apply mobile pagination to one Trustoo review list.
   */
  const enhanceReviewList = (list) => {
    const cards = reviewCards(list);
    const totalReviews = cards.length;

    if (totalReviews === 0) {
      return;
    }

    if (totalReviews <= INITIAL_REVIEW_COUNT) {
      resetReviewList(list);
      return;
    }

    const visibleCount = visibleReviewCount(
      list,
      totalReviews
    );

    list.dataset.schwerVisibleReviews =
      String(visibleCount);

    cards.forEach((card, index) => {
      card.hidden = index >= visibleCount;
    });

    const existingButton =
      list.parentElement?.querySelector(
        ':scope > .schwer-reviews-load-more'
      );

    if (visibleCount >= totalReviews) {
      existingButton?.remove();
      return;
    }

    if (!existingButton) {
      createLoadMoreButton(list);
    }
  };

  /**
   * Apply mobile review layout or remove it on desktop.
   */
  function enhanceReviews() {
    const reviewLists = document.querySelectorAll(
      '.trustoo-widget #reviews-body .tt-review-list'
    );

    if (!reviewLists.length) {
      return;
    }

    const isMobile = window
      .matchMedia(MOBILE_MEDIA_QUERY)
      .matches;

    if (!isMobile) {
      reviewLists.forEach(resetReviewList);
      return;
    }

    reviewLists.forEach(enhanceReviewList);
  }

  /**
   * Initialize all page optimizations.
   */
  const run = () => {
    if (!activatePage()) {
      return;
    }

    enhanceReviews();
  };

  /**
   * Run once when the script loads.
   */
  run();

  /**
   * Trustoo content is loaded asynchronously, so monitor
   * the page for newly inserted review cards.
   */
  const observer = new MutationObserver(() => {
    run();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  /**
   * Recalculate when switching between mobile and desktop.
   */
  window.addEventListener(
    'resize',
    enhanceReviews,
    { passive: true }
  );

  /**
   * Reinitialize sections inside the Shopify theme editor.
   */
  document.addEventListener(
    'shopify:section:load',
    run
  );
})();